import { Component, OnDestroy, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { IntrospectKeysService } from '@core/services/introspect-keys.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'rh-introspect-keys-widget',
    imports: [
        CommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatGridListModule,
        ReactiveFormsModule,
    ],
    templateUrl: './introspect-keys-widget.component.html',
    styleUrl: './introspect-keys-widget.component.scss'
})
export class IntrospectKeysWidgetComponent implements OnDestroy {
  readonly introspectKeysService = inject(IntrospectKeysService);
  readonly key = new FormControl<string>('');

  ngOnDestroy(): void {
    this.introspectKeysService.clear();
  }

  public introspect() {
    if (this.key.valid && this.key.value)
      this.introspectKeysService.introspect({ key: this.key.value });
  }
}
